module.exports = __webpack_public_path__ + "img/67408857fe84505875ec2dae28a8f990.png";